import { useLocalStorage } from '@mantine/hooks';

export interface DashboardBookmark {
  description?: string;
  /** Allow additional unknown properties for extensibility */
  [key: string]: unknown;
}

export const useDashboardBookmarks = () =>
  useLocalStorage<DashboardBookmark[]>({
    key: 'chart-grid-bookmarks',
    defaultValue: [],
    getInitialValueInEffect: false,
  });
